import { apiSlice } from '@/api';
import { CampaignDetailsResponse, CampaignPreviewResponse } from './types';

export const campaignApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCampaign: builder.query<CampaignDetailsResponse, { id: string }>({
      query: ({ id }) => ({
        url: `v1/campaign/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: CampaignDetailsResponse }) =>
        response.result,
    }),
    getAllCampaigns: builder.query<CampaignPreviewResponse[], void>({
      query: () => {
        return `v1/campaign/get/all`;
      },
      transformResponse: (response: { result: CampaignPreviewResponse[] }) =>
        response.result,
    }),
    createCampaign: builder.mutation<
      { result: CampaignDetailsResponse },
      { title: string }
    >({
      query: (body) => ({
        url: 'v1/campaign',
        method: 'POST',
        body,
      }),
    }),
    deleteCampaign: builder.mutation<
      { result: { status: number } },
      { id: string }
    >({
      query: ({ id }) => {
        return {
          url: `v1/campaign/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetCampaignQuery,
  useGetAllCampaignsQuery,
  useCreateCampaignMutation,
  useDeleteCampaignMutation,
} = campaignApi;
